import { createFileRoute, Outlet } from '@tanstack/react-router';
import { z } from 'zod';

const eventsSearchSchema = z
  .object({
    cityId: z.string().uuid().optional(),
    status: z.enum(['DRAFT', 'PENDING_MODERATION', 'PUBLISHED', 'ARCHIVED']).optional(),
    categoryId: z.string().uuid().optional(),
    search: z.string().optional(),
    from: z.string().optional(),
    to: z.string().optional(),
    cursor: z.string().optional(),
  })
  .catch({});

export type EventsSearch = z.infer<typeof eventsSearchSchema>;

export const Route = createFileRoute('/_authenticated/events')({
  staticData: { breadcrumb: 'События' },
  validateSearch: eventsSearchSchema,
  component: () => <Outlet />,
});
